import { useReactiveVar } from '@apollo/client';
import { useEffect } from 'react';

export const useGlobalReactiveVar = (reactiveVar, key) => {
  const result = useReactiveVar(reactiveVar);

  useEffect(() => {
    const onStorageUpdate = event => {
      if (event.key === key) {
        reactiveVar(JSON.parse(event.newValue));
      }
    };

    window.addEventListener('storage', onStorageUpdate);

    return () => {
      window.removeEventListener('storage', onStorageUpdate);
    };
  }, [key, reactiveVar]);

  return result;
};

export const setGlobalReactiveVar = (reactiveVar, key, value) => {
  reactiveVar(value);
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const clearGlobalReactiveVar = (reactiveVar, key) => {
  reactiveVar(undefined);
  window.localStorage.removeItem(key);
};
